import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PageChangedEvent } from 'ngx-bootstrap/pagination';
import { CrewTimecardService } from '../../../pages/crew-timecard/services/crew-timecard.service';

@Component({
  selector: 'app-edit-cell-value-modal',
  templateUrl: './edit-cell-value-modal.component.html',
  styleUrls: ['./edit-cell-value-modal.component.css'],
})
export class EditCellValueModalComponent implements OnInit {
  @Input() options: any[];
  @Input() column: any;
  @Input() mode: string;
  @Input() requestParams: any;

  filteredOptions: any[];
  currentPage: number;
  itemsPerPage: number;
  pagedOptions: any[];
  searchText: string;

  constructor(
    public activeModal: NgbActiveModal,
    private crewTimecardService: CrewTimecardService
  ) {}

  ngOnInit(): void {
    this.currentPage = 1;
    this.itemsPerPage = 10;
    this.filteredOptions = [];
    this.pagedOptions = [];
    this.searchText = null;
    if (this.mode != 'super') this.updatePagedOptions();
  }

  keydownEvent(e) {
    if (e.which === 13) {
      if (this.filteredOptions.length > 0) {
        this.activeModal.close(this.filteredOptions[0].id);
      }
    }
  }

  optionSelected(option) {
    this.activeModal.close(option);
  }

  clearValue() {
    this.activeModal.close({ id: 'null', value: '' });
  }

  pageChanged(event: PageChangedEvent) {
    const begin = (event.page - 1) * this.itemsPerPage;
    const end = begin + this.itemsPerPage;
    this.pagedOptions = this.filteredOptions.slice(begin, end);
  }

  filterChanged() {
    if (this.mode == 'super') {
      if (this.searchText.length > 2) this.getCellValues();
      else {
        this.filteredOptions = [];
        const begin = (this.currentPage - 1) * this.itemsPerPage;
        const end = begin + this.itemsPerPage;
        this.pagedOptions = this.filteredOptions.slice(begin, end);
      }
    } else {
      this.updatePagedOptions();
    }
  }

  updatePagedOptions() {
    this.filteredOptions = [];
    this.options.forEach(option => {
      if (
        this.searchText == null ||
        this.searchText == '' ||
        (option.value != null &&
          option.value.toLowerCase().replace(/ /g, '').indexOf(this.searchText.toLowerCase().replace(/ /g, '')) != -1)
      ) {
        this.filteredOptions.push(option);
      }
    });

    const begin = (this.currentPage - 1) * this.itemsPerPage;
    const end = begin + this.itemsPerPage;
    this.pagedOptions = this.filteredOptions.slice(begin, end);
  }

  getCellValues() {
    const rowData = this.requestParams.rowData;
    rowData.searchString = this.searchText;
    this.crewTimecardService.getCellPossibleValues(rowData).then((response: any) => {
      if (response != null) {
        const options = [];
        response.PossibleValues.forEach((value: any) => {
          options.push({
            id: value.Value + '@row_' + this.requestParams.currentCell.row,
            popUpLabel: value.Label,
            value: value.Label,
          });
        });
        this.filteredOptions = options;
        const begin = (this.currentPage - 1) * this.itemsPerPage;
        const end = begin + this.itemsPerPage;
        this.pagedOptions = this.filteredOptions.slice(begin, end);
      }
    });
  }

  cancelClicked() {
    this.activeModal.dismiss();
  }
}
